import {decorate, inject, injectable} from '@yosmanyga/di';
import {CredentialType} from '@yosmanyga/base';
import {AuthenticationFrontendAsGuestApi} from "@yosmanyga/authentication-frontend";
import {AxiosInstance} from './Axios';

class AuthenticationAsGuestApi implements AuthenticationFrontendAsGuestApi {
    constructor(private axios: AxiosInstance) {
    }

    complete = async (): Promise<CredentialType> => {
        const {data}: { data: CredentialType } = await this.axios
            .withPlatform()
            .withDevice()
            .withLanguage()
            .post(
                '/v1/complete-authentication-as-guest'
            );

        return data;
    };
}

decorate(injectable(), AuthenticationAsGuestApi);
decorate(inject(AxiosInstance), AuthenticationAsGuestApi, 0);

export {AuthenticationAsGuestApi};
